<template>
    <div v-if="service" class="store-container">
        <div
            v-if="userData.is_authenticated && !userData.is_email_verified"
            id="errorContainer"
            class="alert alert-danger text-center"
            role="alert"
        >
            <SvgIcons icon-holder-class="icon-warning" icon-id="icon-warning" />
            <i18n path="shop.verify-email">
                <a v-t="'shop.verify'" place="verifyLink" target="_blank" :href="accountSettingsPageUrl"> </a>
            </i18n>
        </div>
        <store-nav></store-nav>
        <div class="store-content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import storeNav from '@/components/common/store-nav';
import { mapActions, mapState } from 'vuex';
import config from '../config/environment-config';
import { SvgIcons } from '@arena/toolkit';

export default {
    name: 'ShopWrapper',
    components: {
        storeNav,
        SvgIcons,
    },
    props: {},
    data() {
        return {
            accountSettingsPageUrl: `${config[process.env.NODE_ENV][environment.region].account}/setting`,
        };
    },
    computed: {
        ...mapState(['service', 'categories', 'userData']),
        url_service_name() {
            return this.$route.params.service.toLowerCase();
        },
        url_category_id() {
            return this.$route.params.category;
        },
    },
    watch: {
        url_service_name: {
            handler: function() {
                this.$store.commit('resetCategories');
                this.init();
            },
        },
        url_category_id: {
            handler: function() {
                this.initCategory();
            },
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions(['getServices', 'getCategories']),
        init() {
            this.initService();
        },
        async initService() {
            try {
                const services = await this.getServices(this.$i18n.locale);
                if (services.length === 0) {
                    this.$router.push({
                        name: 'error',
                    });
                    return;
                }
                const service = services.find(
                    (service) => service.service_name.toLowerCase() == this.url_service_name.toLowerCase()
                );
                if (!service) {
                    this.$router.push({
                        name: 'service',
                        params: {
                            service: services[0].service_name.toLowerCase(),
                        },
                    });
                    return;
                }
                this.$store.commit('setService', service);
                this.initCategory();
            } catch (error) {
                this.$router.push({
                    name: 'error',
                });
            }
        },
        async initCategory() {
            try {
                const categories =
                    this.categories.length > 0 ? this.categories : await this.getCategories(this.$i18n.locale);

                if (categories.length === 0) {
                    this.$router.push({
                        name: 'error',
                    });
                    return;
                }
                const category = categories.find((category) => category.no == this.url_category_id);
                if (!category) {
                    this.$router.replace({
                        params: {
                            category: categories[0].no,
                        },
                    });
                    return;
                }

                this.$store.commit('setCategory', category);
            } catch (error) {
                this.$router.push({
                    name: 'error',
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.store-container {
    align-items: center;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    &[service='moonlight blade'],
    &[service='Moonlight Blade'] {
        background-image: url('../../public/static/images/products/moonlight-blade/moonlight-blade_bg.png');
    }
    #errorContainer {
        left: 0;
        position: relative;
        top: 0;
        width: 100%;
        &.alert {
            border-radius: 1px;
            margin-bottom: 0;
            a {
                cursor: pointer;
            }
            &.tpa-warning {
                background-color: #bfbfbf;
                color: #000;
            }
        }
    }
    .store-content {
        max-width: 1340px;
        overflow: hidden;
        padding: 0 30px 360px;
        width: 100%;
    }
}
@media (max-width: 768px) {
    .store-container .store-content {
        padding: 0 0 360px;
    }
}
</style>
